import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Textarea } from "@/components/ui/textarea"
import { cn } from "@/lib/utils"

export function ConceptFeedbackDialog({
  open,
  reasons,
  selectedReason,
  additionalFeedback,
  onOpenChange,
  onReasonChange,
  onAdditionalFeedbackChange,
  onSubmit,
  onCancel,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>What&apos;s wrong with this concept?</DialogTitle>
          <DialogDescription>
            Pick the main reason so the concept engine can suppress weak routes.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="grid gap-2 sm:grid-cols-2">
            {reasons.map((reason) => (
              <Button
                key={reason}
                type="button"
                variant="outline"
                aria-pressed={selectedReason === reason}
                onClick={() => onReasonChange?.(reason)}
                className={cn(
                  "h-auto justify-start px-3 py-3 text-left normal-case",
                  selectedReason === reason &&
                    "border-primary/40 bg-primary/10 text-primary hover:bg-primary/10 hover:text-primary",
                )}
              >
                {reason}
              </Button>
            ))}
          </div>

          <div className="space-y-2">
            <label
              htmlFor="concept-feedback-notes"
              className="text-sm font-medium text-foreground"
            >
              Additional feedback
            </label>
            <Textarea
              id="concept-feedback-notes"
              value={additionalFeedback}
              onChange={(event) => onAdditionalFeedbackChange?.(event.target.value)}
              placeholder="Add context for Rob..."
              className="min-h-24 resize-none"
            />
          </div>
        </div>

        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" disabled={!selectedReason} onClick={onSubmit}>
            Submit Feedback
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
